/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import ActionsModal from "./ActionsModal";

const UnsavedChangesModal = ({
  handleClose,
  open,
  message,
  handleAffirmative,
  handleNegative,
}) => (
  <ActionsModal
    handleClose={handleClose}
    open={open}
    title="Unsaved Changes"
    message={message}
    handleAffirmative={handleAffirmative}
    handleNegative={handleNegative}
    affirmativeButtonText="Continue Updating"
    negativeButtonText="Discard Changes"
  />
);

export default UnsavedChangesModal;
